import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import CreditAssessmentAction from '../../../redux/actions/CreditAssessmentAction';
import { CheckoutSelector } from '../../../redux/reducers/CheckoutReducer';
import TypeaheadContainer from '../../../redux/containers/TypeaheadContainer';
import Tooltip from '../../Tooltip/Tooltip';

import FormRadioGroupContainer from '../../../redux/containers/FormRadioGroupContainer';
import './AddressFinder.scss';


const MIN_LENGTH = 5;
const PLACEHOLDER_TEXT = 'Start typing your address';
const NO_ADDRESS_RESULTS = 'Sorry, we didn\'t quite get that address. Please type it again so we can make sure we ' +
  'get the right place.';

class AddressFinder extends React.Component {
  constructor(props) {
    super(props);
    this.fetchAddressesWhenMinLengthMet = this.fetchAddressesWhenMinLengthMet.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  fetchAddressesWhenMinLengthMet(text) {
    if (text && text.length >= MIN_LENGTH) {
      this.props.fetchAddresses(text);
    }
  }

  handleChange(selectedAddresses) {
    const selectedAddress = selectedAddresses[0];
    this.props.fetchCurrentAddressDetails(selectedAddress);
  }

  render() {
    const { currentAddress, resetCurrentAddress } = this.props;
    return (
      <div className="cs-address-search">
        <div className="row">
          <div className="col-xs-12">
            <h3 className="half-charcoal">Address details</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="form-input-container relative">
              <p>Are you a New Zealand resident or citizen? <span className="form-required-text">*</span></p>
              <FormRadioGroupContainer
                name="creditAssessment.isNzResidentOrCitizen"
                radioButtons={[{
                  id: 'yes',
                  label: 'Yes',
                  autotestClass: 'autotest-ca-is-nz-resident-or-citizen-yes'
                }, {
                  id: 'no',
                  label: 'No',
                  autotestClass: 'autotest-ca-is-nz-resident-or-citizen-no'
                }]}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="form-input-container relative">
              <label htmlFor="creditAssessment.currentAddress.addressLine1">
                Where do you live?<span className="form-required-text">*</span>
              </label>
              {isEmpty(currentAddress) &&
              <div className="typeahead-section">
                <TypeaheadContainer
                  {...this.props}
                  name="creditAssessment.currentAddress.addressLine1"
                  addresses={this.props.addresses}
                  emptyLabel={NO_ADDRESS_RESULTS}
                  minLength={MIN_LENGTH}
                  placeholder={PLACEHOLDER_TEXT}
                  onInputChange={this.fetchAddressesWhenMinLengthMet}
                  onChange={this.handleChange}
                />
                <Tooltip title={'Address Tips'} hasIcon>
                  <div className="advice-section">
                    <h4>Address Tips</h4>
                    <p>
                      If you are having trouble finding your address give these suggestions a try:
                    </p>
                    <ul>
                      <li>
                        Start by typing your street number and street name. Our robot is not very good with building
                        or floor names but once it knows your street number it can offer suggestions.
                      </li>
                      <li>
                        You might need to wait a while for results to load, especially on a slower computer or
                        connection, so please be patient as you type.
                      </li>
                      <li>
                        If you live in a big apartment block, it might be easier to start by entering your unit number
                        first, then the street number.
                      </li>
                    </ul>
                  </div>
                </Tooltip>
              </div>
              }
              {!isEmpty(currentAddress) &&
              <div className="address-result">
                <div className="address-box">
                  <div id="address-line-1">{currentAddress.addressLine1}</div>
                  <div id="address-line-2">{currentAddress.addressLine2}</div>
                  <div id="address-line-3">{currentAddress.addressLine3}</div>
                  <div id="address-line-4">{currentAddress.addressLine4}</div>
                </div>
                <button
                  id="ca-change-address"
                  className="btn btn-default btn-secondary"
                  onClick={resetCurrentAddress}
                >Change
                </button>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  addresses: CheckoutSelector.getAddresses(state),
  currentAddress: CheckoutSelector.getCurrentAddress(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    fetchAddresses: CreditAssessmentAction.fetchAddresses,
    fetchCurrentAddressDetails: CreditAssessmentAction.fetchCurrentAddressDetails,
    resetCurrentAddress: CreditAssessmentAction.resetCurrentAddress
  }, dispatch);

// eslint-disable-next-line no-class-assign
AddressFinder = connect(mapStateToProps, mapDispatchToProps)(AddressFinder);

AddressFinder.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.object),
  currentAddress: PropTypes.object,
  fetchAddresses: PropTypes.func,
  fetchCurrentAddressDetails: PropTypes.func,
  resetCurrentAddress: PropTypes.func
};

export default AddressFinder;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep2/AddressFinder.js
 **/